import { render, staticRenderFns } from "./WFieldset.vue?vue&type=template&id=2e1f874c&"
import script from "./WFieldset.vue?vue&type=script&setup=true&lang=js&"
export * from "./WFieldset.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports